import React from 'react';
import { connect } from 'react-redux';

import CharityDetailsComponent from '../../components/app/Charity/CharityDetails';

import * as actions from '../../actions/charity/charity-details';

const CharityDetails = (props) => {
  return (
    <CharityDetailsComponent {...props} />
  );
};

export default connect(({ charity, user }) => ({ charityDetails: charity.charityDetails, user }), actions)(CharityDetails);
